import React, { useEffect } from 'react'
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom'
import PerfectScrollbar from "react-perfect-scrollbar"
import BreadcrumbHeader from '../../../layout/BreadcrumbsHeader'
import { SECONDARY } from '../../../ui-components/CustomButton';
import { Secondary, Primary } from '../../../ui-components/Buttons';import { useTheme } from '@emotion/react'
import ThemeBGWrapper from '../../../ui-components/ThemeBGWrapper'
// import { FetchRoundViewDetails, FetchStartupDetails, FetchViewStartupDetails } from '../../../api'
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Card, CircularProgress, Grid, Tab, Tabs, Typography, useMediaQuery, IconButton, Tooltip } from '@mui/material'
import { makeStyles } from "@mui/styles"
// import { ReactComponent as RoundDetailsIcon } from "../../../assets/rounds_icons/round_details_icon.svg"
// import { ReactComponent as RoundInvestorsIcon } from "../../../assets/rounds_icons/round_investor_icon.svg"
// import { ReactComponent as RoundDocumentsIcon } from "../../../assets/rounds_icons/round_documents.svg"
import RoundInformation from './RoundInformation'
// import RoundDocuments from './RoundDocuments'

import { ReactComponent as InfoIcon } from '../../../assets/help-circle.svg';
import CustomTabs from '../../../ui-components/CustomTabs'
import { containerRef, handleCopyClick, hasPermission } from '../../../utils'
import { Add, ContentCopyOutlined, FileCopy, OpenInNew } from '@mui/icons-material'
import NeedHelpButton from 'ui-components/NeedHelpButton'
import RoundDocuments from './RoundDocuments'
import StartupInformation from './StartupInformation'
import { FetchRoundViewDetails, FetchViewStartupDetails } from 'api/startup_applications'
import Cookies from 'js-cookie'
import ManageNotes from './ManageNotes'
import SubmitFeedback from './SubmitFeedback'
// import Fundings from './Fundings'
import Reports from '../reports/Reports'
import Performance from '../performance'
import { useSelector } from 'react-redux'
import UpdateProfile from '../updateProfile'
import CreateRound from '../rounds/CreateRound'
import Rounds from '../rounds/Rounds'
import ViewFeedback from './ViewFeedback'
import Collaborators from '../settings'
import ViewProfile from './ViewProfile'
import FindInvestors from '../find-investors'
import MatchedInvestors from 'views/backrr_startups/viewDetails/MatchedInvestors'
// import ViewProfile from './ViewProfile'
// import ViewFeedback from './ViewFeedback'
// import RoundInvestorsNew from './RoundInvestorsNew'

const useStyles = makeStyles((theme) => ({
    scrollTabs: {
        '& > .Mui-disabled.MuiTabs-scrollButtons': {
            display: 'none',
            transition: 'all 1s ease'
        }
    }
}));




const ViewDetails = () => {
    const { tab: tabValue } = useParams();
    // console.log(params["*"])
    const theme = useTheme()
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const navigate = useNavigate();
    const isLargeScreen = useMediaQuery(theme.breakpoints.up('md'))
    const classes = useStyles();
    const userPermissions = useSelector((state) => state?.permissions?.userPermissions);
    const [count, setCount] = React.useState(0);
    const Actions = () => {
        return (
            <>
                <NeedHelpButton />
            </>
        );
    };

    const [searchParams, setSearchParams] = useSearchParams();
    // let tabValue = new URLSearchParams(window.location.search).get("page");
    // console.log("tabl",tabValue)

    let roundTabs = [];

    const [value, setValue] = React.useState(tabValue ? tabValue : "view-profile");


    const handleChange = (event, newValue) => {
        newValue === "view-profile" && refetchStartupDetails();
        setValue(newValue);

        navigate("/startups/" + newValue, { replace: true });

        // setSearchParams({ page: newValue })

        // navigate(`/startups/view?page=${}`)
    };

    const [copied, setCopied] = React.useState(false)

    // const [searchParams, setSearchParams] = useSearchParams();
    let startup_id = searchParams.get("startup_id");
    let cookieStartupId = Cookies.get("startup_id");
    // console.log(cookieStartupId, "frgt")

    React.useEffect(() => {
        if (cookieStartupId) {
            // searchParams.delete("startup_id");
            // setSearchParams(searchParams); // Update the URL without startup_id
        } else if (startup_id?.trim()?.length > 0 && startup_id !== null) {
            Cookies.set("startup_id", startup_id);
            navigate("/startups/view-profile", {replace: true})
            // searchParams.delete("startup_id");
            // setSearchParams(searchParams); // Update the URL without startup_id
        } else {
            navigate(-1); // Navigate back if no valid startup_id
        }
    }, [cookieStartupId, startup_id, setSearchParams, navigate, searchParams]);
    // const startup_id = Cookies.get("startup_id");
    const { data: startupDetails, isLoading: isLoadingStartupDetails, refetch: refetchStartupDetails } = FetchViewStartupDetails(cookieStartupId)
    // console.log(startupDetails, "startupDetails");

    const backrrPermissionCookie = Cookies.get("permissions") || null;

    // const manage_notes = window.location?.pathname?.includes("backrr_startups") ?
    //     [{
    //         label: "Matched Investors",
    //         // icon: RoundInvestorsIcon,
    //         value: "matched_investors",
    //         permission: backrrPermissionCookie && JSON.parse(backrrPermissionCookie)?.backrr_startups
    //     },
    //     {
    //         label: "Admin Notes",
    //         // icon: RoundDocumentsIcon,
    //         value: "admin_notes",
    //         permission: backrrPermissionCookie && JSON.parse(backrrPermissionCookie)?.backrr_startups
    //     }] : [{
    //         label: "Notes",
    //         value: "view-notes",
    //         permission: hasPermission("startups_new", "manage_internal_notes", userPermissions)
    //     }]

    const round_details_visible = startupDetails?.data?.round_id ? [
        // {
        //     label: "Round Details",
        //     // icon: RoundInvestorsIcon,
        //     value: "view-round",
        //     permission: hasPermission("startups_new", "view", userPermissions)
        // },
        {
            label: "Documents",
            // icon: RoundDocumentsIcon,
            value: "view-documents",
            permission: hasPermission("startups_new", "view", userPermissions)
        },
    ] : []
    // const admin_view = startupDetail ? [
    //     {
    //         label: "Matched Investors",
    //         // icon: RoundInvestorsIcon,
    //         value: "matched_investors",
    //     },
    //     {
    //         label: "Admin Notes",
    //         // icon: RoundDocumentsIcon,
    //         value: "admin_notes"
    //     },
    // ] : []

    roundTabs = [
        {
            label: "Profile",
            // icon: RoundDetailsIcon,
            value: "view-profile",
            permission: hasPermission("startups_new", "view", userPermissions)
        },
        ...round_details_visible,
        // {
        //     label: "Investors",
        //     icon: RoundInvestorsIcon,
        //     value: "investors",
        // },
        {
            label: "Rounds",
            // icon: RoundDocumentsIcon,
            value: "rounds",
            permission: hasPermission("startups_new", "view", userPermissions)
        },
        {
            label: "Reports",
            // icon: RoundDocumentsIcon,
            value: 'reports',
            permission: hasPermission("startups_new", "view", userPermissions) && hasPermission("reports", "view", userPermissions)
        },
        {
            label: "Performance",
            // icon: RoundDocumentsIcon,
            value: "performance",
            permission: hasPermission("startups_new", "view", userPermissions)
        },
        {
            label: "Feedbacks",
            // icon: RoundDocumentsIcon,
            value: "view-feedback",
            permission: hasPermission("startups_new", "view", userPermissions)
        },
        // ...manage_notes,
        {
            label: "Matched Investors",
            // icon: RoundDocumentsIcon,
            value: "matched-investors",
            permission: hasPermission("startups_new", "view", userPermissions)
        },
        {
            label: "Profile Views",
            // icon: RoundDocumentsIcon,
            value: "profile-views",
            permission: hasPermission("startups_new", "view", userPermissions)
        },
        {
            label: "Users",
            // icon: RoundDocumentsIcon,
            value: "users",
            permission: hasPermission("startups_new", "edit", userPermissions)
        },
        // ,
        // {
        //     label: "Investors Documents",
        //     icon: RoundDetailsIcon,
        //     value: "investors_documents"
        // }
    ]


    const hasPermissionForTab = ({ current_tab }) => {
        return roundTabs?.filter(tab => tab?.permission === true)?.find(item => item?.value === current_tab)?.permission
    }

    // const [showRoundForm, setShowRoundForm] = React.useState(false);
    // console.log(searchParams.get("add-round"), searchParams.get("edit-round"))

    // const showRoundForm = Boolean(searchParams.get("add-round")) || Boolean(searchParams.get("edit-round")) || false;
    // const setShowRoundForm = (mode = "add") => {
    //     if (showRoundForm) {
    //         navigate("/startups/rounds")
    //         // Cookies.remove("showRoundForm")
    //     }
    //     else {
    //         if (mode === "edit") {
    //             navigate("/startups/rounds/edit-round")
    //         }
    //         else {
    //             navigate("/startups/rounds/add-round")
    //         }
    //     }
    //     // navigate("/startups/rounds")
    // }

    // const showViewRoundDetail = Boolean(searchParams.get("view")) || Boolean(searchParams.get("view-investors")) || Boolean(searchParams.get("view-documents")) || false;
    // const setShowViewRoundDetail = (mode = "view") => {
    //     navigate("/startups/rounds")
    //     // Cookies.remove("showRoundForm")
    //     // navigate("/startups/rounds")
    // }
    // console.log(userPermissions["startups_new"]['edit'], "tabValue")
    return (
        // tabValue === "add" || tabValue === "edit" ? <UpdateProfile /> :
        (<ThemeBGWrapper bgColor={theme.palette.customColors.yellow_bg}>
            <BreadcrumbHeader title={() => <Box display={"flex"} alignItems={"center"}>
                <>{
                    isLoadingStartupDetails
                        ? "Loading..."
                        : isSmallScreen
                            ? "View Details"
                            : startupDetails?.data?.startup_name
                                ? startupDetails?.data?.startup_name
                                : "View Details"
                } <Tooltip title="View Profile">
                        <IconButton
                            onClick={() => window.open(startupDetails?.data?.backrr_base_url, '_blank')}
                        >
                            <OpenInNew sx={{ height: 25 }} />
                        </IconButton>
                    </Tooltip> </></Box>} Actions={Actions} sx={{ paddingBottom: 0 }} />
            {isLoadingStartupDetails ?
                <Grid item xs={12} height={"100dvh"} sx={{ width: '100%', padding: "2rem", paddingTop: "1rem", bgColor: theme.palette.customColors.yellow_bg }}>
                    {/* <CircularProgress sx={{ color: theme?.palette.customColors.b300 }} /> */}
                    <Box className='skeleton' height={80}>

                    </Box>
                    <Box className='skeleton' height={"calc(100% - 80px)"} marginTop={2}>

                    </Box>
                </Grid>
                : <>


                    <Grid xs={12} container bgColor={theme.palette.customColors.yellow_bg} height={"100%"}>
                        <Box sx={{ width: '100%', typography: 'body1' }}>
                            <TabContext value={value}>
                                <Box px={isSmallScreen ? "1rem" : "2rem"} bgColor={theme.palette.customColors.yellow_bg} display={"flex"} flexWrap={"nowrap"}
                                    sx={{ alignItems: 'center', justifyContent: 'space-between' }}
                                >
                                    <Box sx={{ width: (tabValue === "rounds" && hasPermission("startups_new", "edit", userPermissions)) || (tabValue === "reports" && hasPermission("startups_new", "edit", userPermissions)) ? "80%" : '100%' }}>
                                        <CustomTabs data={
                                            [...roundTabs?.filter(tab => tab?.permission === true)?.map(item => {
                                                return ({ ...item, label: `${item?.label} ${item?.value === value && value === "matched-investors" && count && count !== null ? `(${count})` : ""}` })
                                            })]
                                        } value={value} isSmallScreen={isSmallScreen} className={classes} titleStyle={{ fontSize: '1.10rem' }} handleChange={handleChange} key={"Tabs Tabs"} sx={{ paddingTop: '1rem' }} bgColor={theme.palette.customColors.yellow_bg} />
                                    </Box>
                                    {/* {console.log(tabValue === "rounds", hasPermission("startups_new", "edit", userPermissions), "tabValue")} */}
                                    <Box sx={{ paddingTop: "0.5rem" }}>
                                        {
                                            tabValue === "rounds" && hasPermission("startups_new", "edit", userPermissions) && <Primary sx={{
                                                borderRadius: "8px",
                                                textTransform: "none", bgcolor: theme.palette.customColors.indigo600, border: `1px solid ${theme.palette.customColors.indigo600}`, padding: '10px 16px', fontWeight: 600, minWidth: isSmallScreen ? "0" : '64px', '& > .MuiButton-icon.MuiButton-startIcon': { marginRight: isSmallScreen ? 0 : '8px', marginLeft: isSmallScreen ? 0 : '-4px' }
                                            }} startIcon={<Add fontSizCe='1.25rem' />}
                                                onClick={() => {
                                                    Cookies.remove("round_id");
                                                    navigate("/startups/rounds/add-round")
                                                    // setShowRoundForm();
                                                }}
                                            >
                                                {!isSmallScreen ? !isLargeScreen ? "Add" : "Add Round" : ''}
                                            </Primary>
                                        }
                                        {
                                            tabValue === "reports" && hasPermission("startups_new", "edit", userPermissions) && <Primary sx={{
                                                borderRadius: "8px",
                                                textTransform: "none", bgcolor: theme.palette.customColors.indigo600, border: `1px solid ${theme.palette.customColors.indigo600}`, padding: '10px 16px', fontWeight: 600, minWidth: isSmallScreen ? "0" : '64px', '& > .MuiButton-icon.MuiButton-startIcon': { marginRight: isSmallScreen ? 0 : '8px', marginLeft: isSmallScreen ? 0 : '-4px' }
                                            }} startIcon={<Add fontSizCe='1.25rem' />}
                                                onClick={() => {
                                                    Cookies.remove("report_id");
                                                    navigate("/startups/reports/add-report")
                                                    // setShowRoundForm();
                                                }}
                                            >
                                                {!isSmallScreen ? !isLargeScreen ? "Add" : "Add Report" : ''}
                                            </Primary>
                                        }
                                    </Box>
                                </Box>
                                {hasPermissionForTab({ current_tab: "view-profile" }) && <TabPanel value="view-profile" sx={{ paddingInline: 0, height: '100%' }}>
                                    <PerfectScrollbar containerRef={containerRef} style={{ height: isLargeScreen ? "calc(100dvh - 190px)" : "calc(100dvh - 185px)", paddingInline: isSmallScreen ? "1rem" : "2rem" }}>
                                        <StartupInformation data={startupDetails?.data} round_id={"wefrtg"} />
                                    </PerfectScrollbar>
                                </TabPanel>}
                                {/* {startupDetails?.data?.round_id && hasPermissionForTab({ current_tab: "view-round" }) && <TabPanel value="view-round" sx={{ paddingInline: 0, height: '100%' }}>
                                        <PerfectScrollbar containerRef={containerRef} style={{ height: isLargeScreen ? "calc(100dvh - 190px)" : "calc(100dvh - 185px)", paddingInline: isSmallScreen ? "1rem" : "2rem" }}>
                                            <RoundInformation data={{}} round_id={startupDetails?.data?.round_id} />
                                        </PerfectScrollbar>
                                    </TabPanel>} */}
                                {startupDetails?.data?.round_id && hasPermissionForTab({ current_tab: "view-documents" }) && <TabPanel value="view-documents" sx={{ paddingInline: 0, height: '100%' }}>
                                    <PerfectScrollbar containerRef={containerRef} style={{ height: isLargeScreen ? "calc(100dvh - 190px)" : "calc(100dvh - 185px)", paddingInline: isSmallScreen ? "1rem" : "2rem" }}>
                                        <RoundDocuments round_id={startupDetails?.data?.round_id} startup_name={startupDetails?.data?.startup_name} />
                                    </PerfectScrollbar>
                                </TabPanel>}
                                {hasPermissionForTab({ current_tab: "view-notes" }) && <TabPanel value="view-notes" sx={{ paddingInline: 0, height: '100%' }}>
                                    <PerfectScrollbar containerRef={containerRef} style={{ height: isLargeScreen ? "calc(100dvh - 190px)" : "calc(100dvh - 185px)", paddingInline: isSmallScreen ? "1rem" : "2rem" }}>
                                        <ManageNotes data={startupDetails?.data} startup_id={cookieStartupId} />
                                    </PerfectScrollbar>
                                </TabPanel>}
                                {hasPermissionForTab({ current_tab: "view-feedback" }) && <TabPanel value="view-feedback" sx={{ paddingInline: 0, height: '100%' }}>
                                    {/* <PerfectScrollbar containerRef={containerRef} style={{ height: isLargeScreen ? "calc(100dvh - 190px)" : "calc(100dvh - 185px)", paddingInline: isSmallScreen ? "1rem" : "2rem" }}> */}
                                    <ViewFeedback />
                                    {/* </PerfectScrollbar> */}
                                </TabPanel>}
                                {hasPermissionForTab({ current_tab: "rounds" }) && <TabPanel value="rounds" sx={{ paddingInline: 0, height: '100%' }}>
                                    {/* <PerfectScrollbar containerRef={containerRef} style={{ height: isLargeScreen ? "calc(100dvh - 190px)" : "calc(100dvh - 185px)", paddingInline: isSmallScreen ? "1rem" : "2rem" }}> */}
                                    {/* <Fundings /> */}
                                    {/* {showRoundForm ? <CreateRound startup_name={startupDetails?.data?.startup_name} setShowRoundForm={setShowRoundForm} /> : showViewRoundDetail ? <ViewRound tabValue={
                                        Boolean(searchParams.get("view")) ? "view_details" : Boolean(searchParams.get("view-investors")) ? "round_investors" : Boolean(searchParams.get("view-documents")) ? "documents" : "view_details"
                                    } setShowViewRoundDetails={setShowViewRoundDetail} startup_name={startupDetails?.data?.startup_name} /> : <Rounds setShowRoundForm={setShowRoundForm} startup_name={startupDetails?.data?.startup_name} />} */}
                                    <Rounds startup_name={startupDetails?.data?.startup_name} startup_slug={startupDetails?.data?.slug} />
                                    {/* </PerfectScrollbar> */}
                                </TabPanel>}
                                {hasPermissionForTab({ current_tab: "reports" }) && <TabPanel value="reports" sx={{ paddingInline: 0, height: '100%' }}>
                                    {/* <PerfectScrollbar containerRef={containerRef} style={{ height: isLargeScreen ? "calc(100dvh - 190px)" : "calc(100dvh - 185px)", paddingInline: isSmallScreen ? "1rem" : "2rem" }}> */}
                                    <Reports startup_details_id={cookieStartupId} />
                                    {/* </PerfectScrollbar> */}
                                </TabPanel>}
                                {hasPermissionForTab({ current_tab: "performance" }) && <TabPanel value="performance" sx={{ paddingInline: 0, height: '100%' }}>
                                    {/* <PerfectScrollbar containerRef={containerRef} style={{ height: isLargeScreen ? "calc(100dvh - 190px)" : "calc(100dvh - 185px)", paddingInline: isSmallScreen ? "1rem" : "2rem" }}> */}
                                    {/* <Performance startup_id={cookieStartupId} /> */}
                                    <Performance />
                                    {/* </PerfectScrollbar> */}
                                </TabPanel>}
                                {hasPermissionForTab({ current_tab: "profile-views" }) && <TabPanel value="profile-views" sx={{ paddingInline: 0, height: '100%' }}>
                                    {/* <PerfectScrollbar containerRef={containerRef} style={{ height: isLargeScreen ? "calc(100dvh - 190px)" : "calc(100dvh - 185px)", paddingInline: isSmallScreen ? "1rem" : "2rem" }}> */}
                                    {/* <Performance startup_id={cookieStartupId} /> */}
                                    <ViewProfile />
                                    {/* </PerfectScrollbar> */}
                                </TabPanel>}
                                {hasPermissionForTab({ current_tab: "matched-investors" }) && <TabPanel value="matched-investors" sx={{ paddingInline: 0, height: '100%' }}>
                                    <PerfectScrollbar containerRef={containerRef} style={{ height: isLargeScreen ? "calc(100dvh - 190px)" : "calc(100dvh - 185px)", paddingInline: isSmallScreen ? "1rem" : "2rem" }}>
                                        <MatchedInvestors startup_id={cookieStartupId} setCount={setCount} count={count} />
                                    </PerfectScrollbar>
                                </TabPanel>}
                                {hasPermissionForTab({ current_tab: "users" }) && <TabPanel value="users" sx={{ paddingInline: 0, height: '100%' }}>
                                    {/* <PerfectScrollbar containerRef={containerRef} style={{ height: isLargeScreen ? "calc(100dvh - 190px)" : "calc(100dvh - 185px)", paddingInline: isSmallScreen ? "1rem" : "2rem" }}> */}
                                    {/* <Performance startup_id={cookieStartupId} /> */}
                                    <Collaborators />
                                    {/* </PerfectScrollbar> */}
                                </TabPanel>}
                            </TabContext>
                        </Box>
                    </Grid>
                </>
            }
        </ThemeBGWrapper>
        )
    )
}

export default ViewDetails